module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"header":"Lista de links de pagamento","btn-create":"Criar novo link"},"en-US":{"header":"List of payment links","btn-create":"Create new link"}}')
  delete Component.options._Ctor
}
